var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPercentage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 55,
    viewBox: "0 0 50 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_248_4085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7745 0.175999C16.6332 0.175999 18.9585 1.072 20.7505 2.864C22.5425 4.61333 23.4385 7.00267 23.4385 10.032C23.4385 13.0613 22.5425 15.4507 20.7505 17.2C18.9585 18.9493 16.6332 19.824 13.7745 19.824C10.9158 19.824 8.56917 18.9493 6.7345 17.2C4.9425 15.4507 4.0465 13.0613 4.0465 10.032C4.0465 7.00267 4.9425 4.61333 6.7345 2.864C8.56917 1.072 10.9158 0.175999 13.7745 0.175999ZM40.8465 0.751999L15.3105 46H8.1425L33.7425 0.751999H40.8465ZM9.0385 10.032C9.0385 11.6533 9.46517 12.9547 10.3185 13.936C11.1718 14.8747 12.3025 15.344 13.7105 15.344C15.1185 15.344 16.2492 14.8533 17.1025 13.872C17.9985 12.8907 18.4465 11.6107 18.4465 10.032C18.4465 8.41066 17.9985 7.10933 17.1025 6.128C16.2492 5.14666 15.1185 4.656 13.7105 4.656C12.3025 4.656 11.1718 5.14666 10.3185 6.128C9.46517 7.10933 9.0385 8.41066 9.0385 10.032ZM35.2785 26.928C38.1372 26.928 40.4625 27.8027 42.2545 29.552C44.0892 31.3013 45.0065 33.6907 45.0065 36.72C45.0065 39.7493 44.0892 42.16 42.2545 43.952C40.4625 45.7013 38.1372 46.576 35.2785 46.576C32.4625 46.576 30.1372 45.7013 28.3025 43.952C26.5105 42.16 25.6145 39.7493 25.6145 36.72C25.6145 33.7333 26.5105 31.3653 28.3025 29.616C30.1372 27.824 32.4625 26.928 35.2785 26.928ZM30.6065 36.72C30.6065 38.3413 31.0332 39.6427 31.8865 40.624C32.7398 41.6053 33.8705 42.096 35.2785 42.096C36.6865 42.096 37.8172 41.6053 38.6705 40.624C39.5665 39.6427 40.0145 38.3413 40.0145 36.72C40.0145 35.1413 39.5665 33.8613 38.6705 32.88C37.8172 31.8987 36.6865 31.408 35.2785 31.408C33.8705 31.408 32.7398 31.8987 31.8865 32.88C31.0332 33.8613 30.6065 35.1413 30.6065 36.72Z",
    fill: "#4DA936"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_248_4085",
    x: 0.0465088,
    y: 0.176025,
    width: 48.9601,
    height: 54.3999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_248_4085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_248_4085",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.2649ae22612048460d530a6a4cbc1b13.svg";
export { ForwardRef as ReactComponent };